import { nowCDT, dateToCDT } from '../dateUtils';

function GoalsChart({ goalsData }) {
  const days = getLast7Days();

  const timGoals = goalsData.goals.filter((g) => g.person === 'Tim' && g.frequency === 'daily');
  const emilioGoals = goalsData.goals.filter((g) => g.person === 'Emilio' && g.frequency === 'daily');

  function getLast7Days() {
    const result = [];
    const now = nowCDT();
    for (let i = 6; i >= 0; i--) {
      const d = new Date(now);
      d.setDate(d.getDate() - i);
      result.push({
        date: dateToCDT(d),
        label: d.toLocaleDateString('en-US', { weekday: 'short', timeZone: 'America/Chicago' }),
        dayNum: d.getDate(),
      });
    }
    return result;
  }

  function isCompleted(goalId, date) {
    return goalsData.completions.some(
      (c) => c.goalId === goalId && c.date === date
    );
  }

  return (
    <section className="card goals-chart-section">
      <h2>Goals Tracker - Last 7 Days</h2>
      {timGoals.length > 0 && (
        <PersonGrid name="Tim" goals={timGoals} days={days} isCompleted={isCompleted} />
      )}
      {emilioGoals.length > 0 && (
        <PersonGrid name="Emilio" goals={emilioGoals} days={days} isCompleted={isCompleted} />
      )}
      {timGoals.length === 0 && emilioGoals.length === 0 && (
        <p className="empty">No daily goals to track</p>
      )}
      <div className="goals-chart-summary">
        {[{ name: 'Tim', goals: timGoals }, { name: 'Emilio', goals: emilioGoals }]
          .filter(({ goals }) => goals.length > 0)
          .map(({ name, goals }) => {
            const totalPossible = goals.length * 7;
            const totalDone = days.reduce((sum, day) => {
              return sum + goals.filter((g) => isCompleted(g.id, day.date)).length;
            }, 0);
            const pct = Math.round((totalDone / totalPossible) * 100);
            return (
              <div key={name} className="chart-summary-item">
                <span className="chart-summary-name">{name}</span>
                <div className="chart-summary-bar">
                  <div className="chart-summary-fill" style={{ width: `${pct}%` }} />
                </div>
                <span className="chart-summary-pct">{pct}%</span>
              </div>
            );
          })}
      </div>
    </section>
  );
}

function PersonGrid({ name, goals, days, isCompleted }) {
  return (
    <div className="goals-chart-person">
      <h3>{name}</h3>
      <div className="goals-grid" style={{ gridTemplateColumns: `120px repeat(${days.length}, 1fr)` }}>
        {/* Header row */}
        <div className="grid-header grid-label" />
        {days.map((day) => (
          <div key={day.date} className="grid-header">
            <span className="grid-day-name">{day.label}</span>
            <span className="grid-day-num">{day.dayNum}</span>
          </div>
        ))}
        {/* Goal rows */}
        {goals.map((goal) => (
          <GoalRow key={goal.id} goal={goal} days={days} isCompleted={isCompleted} />
        ))}
      </div>
    </div>
  );
}

function GoalRow({ goal, days, isCompleted }) {
  return (
    <>
      <div className="grid-goal-name">{goal.title}</div>
      {days.map((day) => {
        const done = isCompleted(goal.id, day.date);
        return (
          <div key={day.date} className={`grid-cell ${done ? 'done' : 'missed'}`}>
            {done ? '\u2705' : '\u2796'}
          </div>
        );
      })}
    </>
  );
}

export default GoalsChart;
